module.exports = __webpack_public_path__ + "img/deadmau5-0d40d78a-76ed-4887-d676-08d957755ecc.png";